<template>
  <v-card v-if="dangers.length" class="active-dangers" elevation="4">
    <v-card-item>
      <template #prepend>
        <v-icon color="danger" size="large">mdi-alert</v-icon>
      </template>
      <v-card-title>Dangers actifs</v-card-title>
      <v-card-subtitle class="text-wrap">
        {{ dangers.length }} danger{{ dangers.length > 1 ? "s" : "" }} signalé{{ dangers.length > 1 ? "s" : "" }} par la
        communauté sur les rivières du Québec
      </v-card-subtitle>
    </v-card-item>
    <v-list density="compact" class="py-0">
      <v-list-item
        v-for="danger in shownDangers"
        :key="danger.id"
        :to="{ name: 'riviere', params: { slug: danger.section_alias }, query: { onglet: 'dangers' } }"
        lines="two"
      >
        <template #prepend>
          <v-icon :color="needsReconfirmation(danger) ? 'warning' : 'error'" size="small">mdi-alert-outline</v-icon>
        </template>
        <v-list-item-title class="font-weight-medium">{{ danger.river }} - {{ danger.section_name }}</v-list-item-title>
        <v-list-item-subtitle>
          {{ dangerSummary(danger) }} · depuis le {{ formatDangerDate(danger.start_date) }}
        </v-list-item-subtitle>
      </v-list-item>
    </v-list>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="danger" variant="text" append-icon="mdi-arrow-right" :to="{ name: 'dangers' }">
        Voir tous les dangers
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  import { DangersService } from "@/store/modules/dangers";
  import { dangerSummary, formatDangerDate, needsReconfirmation } from "@/utils/dangers";

  // Most recent active dangers of every section. Hidden when there are none.
  export default {
    name: "ActiveDangersCard",
    props: {
      limit: { type: Number, default: 5 },
    },
    // loaded: the dangers are shown (or there are none), e.g. to signal the prerenderer.
    emits: ["loaded"],
    data() {
      return { dangers: [] };
    },
    computed: {
      shownDangers() {
        return this.dangers.slice(0, this.limit);
      },
    },
    async mounted() {
      try {
        this.dangers = await DangersService.actions.getActiveDangers();
      } catch (error) {
        console.error("Error fetching active dangers:", error);
      } finally {
        this.$nextTick(() => this.$emit("loaded"));
      }
    },
    methods: {
      dangerSummary,
      formatDangerDate,
      needsReconfirmation,
    },
  };
</script>

<style lang="scss" scoped>
  .active-dangers {
    border-top: 4px solid rgb(var(--v-theme-error));
  }
</style>
